import { modelHelperModule } from './model-helper';
import { appConfig } from '../constants/app-config';
import { isLoggedIn } from '../utils/account-utils/account-utils';

export const challengeItemModelModule = angular
  .module('Q.models.challenge-item', [modelHelperModule])

  .factory('ChallengeItem', function (DS, ModelHelper, $q, $injector) {
    return ModelHelper.defineResource({
      name: 'ChallengeItem',
      endpoint: 'challenge_items',

      cleanAfterDestroy: {
        parent: 'Assessment',
        collection: 'challengeItems',
      },

      methods: {
        getChallenge() {
          let promise;

          if (this.challenge) {
            promise = $q.when(this.challenge);
          } else if (this.challengeId && isLoggedIn($injector)) {
            promise = DS.definitions.Challenge.fetch(this.challengeId, {
              params: { includes: ['sourced_from'] },
            });
          } else {
            promise = $q.when(null);
          }
          return promise
            .then((c) => c && c.loadSourcedFrom())
            .catch(() => null);
        },
        availableLanguages() {
          // get a list of all available challenge languages that aren't filtered out
          return this.challenge
            .getLanguages()
            .filter((lang) => !this.disabledLanguages.includes(lang.id));
        },
      },

      staticMethods: {
        /**
         * Loads all missing challenges in a given array of challengeItems
         *
         * @param {Array} challengeItems
         * @returns {Promise} promise upon completion with the challengeItems
         */
        loadMissingChallenges(challengeItems) {
          // don't look up challenges on reports
          if (appConfig.appId === 'reports') {
            return $q.resolve(challengeItems);
          }

          const challengeIds = [];
          const missingIdsMap = {};
          const Challenge = DS.definitions.Challenge;
          challengeItems.forEach(function (ci) {
            if (!ci.challenge && ci.challengeId) {
              let c = Challenge.get(ci.challengeId);
              if (!c) {
                if (!missingIdsMap[ci.challengeId]) {
                  challengeIds.push(ci.challengeId);
                  missingIdsMap[ci.challengeId] = [ci];
                } else {
                  missingIdsMap[ci.challengeId].push(ci);
                }
              } else {
                // grab sourced from in the same load if we need it
                if (!c.sourcedFrom && c.sourcedFromId) {
                  challengeIds.push(c.sourcedFromId);
                }
              }
            }
          });

          let promise;

          if (challengeIds.length) {
            promise = DS.definitions.Challenge.findAll({
              where: { id: { in: challengeIds } },
              includes: ['sourced_from'],
            }).then((challenges) => {
              challenges.forEach((c) => {
                missingIdsMap[c.id].forEach((ci) => (ci.challenge = c));
              });
              return challengeItems;
            });
          } else {
            promise = $q.resolve(challengeItems);
          }

          return (
            promise
              // load missing copied from (for stats)
              .then((cis) =>
                Challenge.loadSourcedFrom(
                  cis.map((ci) => ci.challenge).filter(angular.identity),
                ),
              )
              .then(() => challengeItems)
          );
        },
      },

      relations: {
        hasOne: {
          Challenge: {
            localField: 'challenge',
            localKey: 'challengeId',
          },
        },
      },

      meta: {
        saveExcludes: ['challenge'],
      },
    });
  });
